import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/dilemmaReflection.css";
import useTranslation from "../hooks/useTranslation";

function DilemmaReflection({ updateProgress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleContinue = () => {
    updateProgress('dilemma-reflection');
    navigate('/transformation-instructions');
  };

  return (
    <div className="dilemma-reflection-container">
      {/* Contenido central */}
      <div className="dilemma-reflection-content">
        <div className="dilemma-reflection-header">
          <h1 className="game-titleP">{t('dilemmaReflection.gameTitle')}</h1>
          <h2 className="game-subtitleP">{t('dilemmaReflection.gameSubtitle')}</h2>
        </div>

        <div className="dilemma-instructions-box">
          <h2 className="dilemma-instructions-title">{t('dilemmaReflection.title')}</h2>
          <h3 className="dilemma-instructions-subtitle">{t('dilemmaReflection.subtitle')}</h3>
          
          <div className="dilemma-instructions-text">
            <p>
              {t('dilemmaReflection.paragraph1')}
            </p>
            
            <p>
              {t('dilemmaReflection.paragraph2')}
            </p>
            
            <p>
              {t('dilemmaReflection.paragraph3')}
            </p>
            
            <div className="reflection-questions">
              <strong>{t('dilemmaReflection.questionsTitle')}</strong>
              <ul>
                <li>{t('dilemmaReflection.question1')}</li>
                <li>{t('dilemmaReflection.question2')}</li>
                <li>{t('dilemmaReflection.question3')}</li>
                <li>{t('dilemmaReflection.question4')}</li>
              </ul>
            </div>
            
            <p>
              {t('dilemmaReflection.paragraph4')}
            </p>
          </div>

          <button className="dilemma-continue-button" onClick={handleContinue}>
            {t('dilemmaReflection.continueButton')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DilemmaReflection;







